import { jsx as _jsx } from "react/jsx-runtime";
import { RecordingIndicator } from '@streamr/tv-ui';
import { useRef } from 'react';
import { RecordingService } from '../../../services/recording/RecordingService';
import { assert } from '../../../utils/assert';
import { BottomLeft } from '../../../utils/popups';
import { PopupCssPreset } from '../../popups/Popup.styles';
import { showStopRecordingPopup, } from '../../popups/recording/StopRecordingPopup';
const mobilePositioningForStopRecordingPopup = {
    fullscreenOnly: true,
};
const desktopPositioningForStopRecordingPopup = {
    fullscreenOnly: false,
    translateFn: BottomLeft,
    popupCssPresetForDesktop: PopupCssPreset.AnchoredBottomRight,
};
export const RecordingStatusIndicator = ({ isMobile, broadcast, }) => {
    const anchorRef = useRef(null);
    const activeRecording = RecordingService.getOutput().useActiveRecording();
    const onStopRecording = async () => {
        assert(activeRecording, 'Recording is not active');
        const shouldStop = await showStopRecordingPopup({
            anchorRef,
            positioning: isMobile
                ? mobilePositioningForStopRecordingPopup
                : desktopPositioningForStopRecordingPopup,
            broadcast,
            isPublic: activeRecording.visibility === 'public',
        });
        if (shouldStop) {
            RecordingService.getNotificationInterface().notifyStopRecording();
        }
    };
    const onCancelInitialization = () => {
        RecordingService.getNotificationInterface().notifyStopRecording();
    };
    const onRetry = () => {
        RecordingService.getNotificationInterface().notifyRetryInitialization();
    };
    const onButtonClick = () => {
        if (activeRecording?.status === 'recording') {
            onStopRecording();
        }
        else if (activeRecording?.status === 'initializing') {
            onCancelInitialization();
        }
        else if (activeRecording?.status === 'error') {
            onRetry();
        }
    };
    return (activeRecording !== undefined && (_jsx("div", { ref: anchorRef, children: _jsx(RecordingIndicator, { status: activeRecording.status, onButtonClick: onButtonClick, shape: isMobile ? 'circle' : 'square' }) })));
};
